import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import ErrorComponent from "../../Components/ErrorComponent";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import {
  KeyboardArrowLeft,
  CloseOutlined,
} from "@mui/icons-material";
import ListContent from "./ListContent";

function ReqMedical3() {
  const {
    selectedProcedureClass,
    setSearchBranchResults,
    setAvailableClinics,
    selectedProcedures,
    getProcedureClass,
    setSelectedClinic,
    setDisplayAlert,
    setSearchBranch,
    getProviders,
    pcLoadState,
    handleBack,
    loadState,
    navigate,
    files,
  } = useRequestMedicalContext();

  const handleNext = async () => {
    setSelectedClinic();
    setSearchBranch("");
    setSearchBranchResults([]);
    setAvailableClinics([]); // Clear available clinics initially
    try {
      await getProviders();
    } catch (error) {
      console.log(error);
    } finally{
      navigate("/request-medical-test/choose-clinic");
    }
  };

  const stepThreeValidation =
    files.length > 0
      ? selectedProcedureClass.length > 0
      : selectedProcedures.length > 0
      ? selectedProcedures?.every((data) => data.coveredProcedures.length > 0)
      : null;

  let content = null;
  if(pcLoadState === "get"){
    content = (
      <div className="w-full flex justify-center items-center mt-4">
        <CircularProgress />
      </div>
    );
  } else if (["ISE", "timeout", "retry"].includes(pcLoadState)) {
    content = (
      <ErrorComponent
        onRetry={() => getProcedureClass("retry")}
        isLoading={pcLoadState === "retry"}
      />
    );
  } else {
    content = <ListContent/>;
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Request Medical Test
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
        </div>
        <div className="w-full p-3">
          <div>
            <CustomizedProgressBar value={42.84} />
          </div>
          <div className="w-full text-sm text-[#60656D] mt-4">
            Select the procedures listed on your diagnostic order
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="px-3">
            {content}
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full p-4">
          <Button
            disabled={!stepThreeValidation || loadState === "get providers"}
            className={`h-14 w-full sm:w-22.5 rounded-xl ${
              !stepThreeValidation || loadState === "get providers"
                ? "bg-[#F6F7F7]"
                : "bg-[#0053CC]"
            }`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                !stepThreeValidation || loadState === "get providers"
                  ? "text-[#A3A7AB]"
                  : "text-white"
              }`}
            >
              {loadState === "get providers" ? <CircularProgress size={"1rem"} /> : "Continue"}
            </p>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReqMedical3;
